import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { RefreshButton, useAppBar } from "../../../../components";
import { Breadcrumb, Child } from "../../../../models";
import { useGetChildByIdQuery, useGetFamilyByIdQuery } from "../../../../redux/apiStore";
import { getFamilyDetailBreadcrumb } from "../../detail/FamilyDetailAppBarSetup";
import { getFamiliesBreadcrumb } from "../../main";

export function getChildDetailBreadcrumb(child?: Child): Breadcrumb | null {
  if (!child) return null;
  return {
    title: child.firstName,
    path: `/families/${child.familyId}/children/${child.id}`,
  };
}

export function ChildDetailAppBarSetup() {
  const params = useParams();
  const familyId = parseInt(params.familyId || "");
  const childId = parseInt(params.childId || "");
  const appBar = useAppBar();
  const getFamilyById = useGetFamilyByIdQuery({ id: familyId });
  const getChildById = useGetChildByIdQuery({ id: childId });
  const family = getFamilyById.data;
  const child = getChildById.data;

  useEffect(() => {
    appBar.setDefaults();
    appBar.setTitle(child ? `${child.firstName} ${child.lastName}` : "Child Details");
    appBar.setBackUrl(`/families/${child?.familyId}`);
    appBar.setBreadcrumbs([getFamiliesBreadcrumb(), getFamilyDetailBreadcrumb(family), getChildDetailBreadcrumb(child)].filter((x) => !!x));
    appBar.setRightContent(
      <RefreshButton
        onRefresh={() => {
          Promise.all([getFamilyById.refetch(), getChildById.refetch()]);
        }}
      />,
    );
  }, [family, child]);

  return null;
}
